<template>
  <EquipmentTypeTable />
</template>

<script>
import EquipmentTypeTable from '@/components/equipmenttype/EquipmentTypeTable.vue'

export default {
  name: 'EquipmentTypeView',
  components: {EquipmentTypeTable},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
